import { FC, InputHTMLAttributes, ReactNode } from "react";
import InputFrame from "../atoms/InputFrame";
import MiniLoading from "../ions/MiniLoading";

export type OptionProps = {
    value: string;
    label: string;
}

interface SelectTextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'prefix'> {
    label: string;
    errorMessage?: string;
    onChange: (e: any) => void;
    items: OptionProps[];
    emptyValue?: string;
    emptyLabel?: string;
    prefix?: ReactNode;
    isLoading?: boolean;
    /** oculta a opção vazia inicial — para selects obrigatórios que sempre têm um valor válido */
    hideEmptyOption?: boolean;
}

const SelectTextField: FC<SelectTextFieldProps> = ({ id, name, label,
    errorMessage, items,
    className,
    prefix,
    value, onChange,
    emptyValue = '',
    emptyLabel = 'Selecione um registro...',
    disabled = false, isLoading = false, hideEmptyOption = false }) => {

    const error = Boolean(errorMessage);
    const borderColor = error ? "border-red-600 dark:border-red-400" : "border-gray-300 dark:border-gray-600";


    return (

        <InputFrame
            label={label}
            htmlFor={id}
            errorMessage={errorMessage}
            className={className}
            prefix={prefix}
        >
            {isLoading && (
                <MiniLoading />
            )}
            <select id={id}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className={`block py-2.5 px-0 w-full text-sm bg-transparent border-0 border-b-2 ${borderColor} appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer disabled:opacity-50 disabled:cursor-not-allowed dark:text-white`}
            >
                {!hideEmptyOption && <option value={emptyValue}>{emptyLabel}</option>}

                {items && items.map((item, index) => (
                    <option key={index} value={item.value}>
                        {item.label}
                    </option>
                ))}
            </select>
        </InputFrame>
    );
}

export default SelectTextField;